import { useUserLogin } from '@hotjar/auth/src/domains/authentication/useUserLogin';
import { useEffectOnce } from 'react-use';
import { navigateTo } from '@hotjar/webapp/utils/routing';
import { LOGIN } from '@hotjar/webapp/constants/routes/auth';
import { getLoggedIn, clearUserData } from '@hotjar/webapp/domains/common/user-data';
import { useIsDemoUser } from '@hotjar/webapp/hooks/useIsDemoUser';
import { useSiteStore } from '@hotjar/site';

export const Logout = (): null => {
  const { logoutAndClearData } = useUserLogin();
  const isLoggedIn = getLoggedIn();
  const isLoggedInDemo = useIsDemoUser();
  const { setPreferredCurrentSiteId } = useSiteStore();

  useEffectOnce(() => {
    if (isLoggedIn) {
      logoutAndClearData(() => {
        clearUserData();
        setPreferredCurrentSiteId(undefined);
        navigateTo(LOGIN.path);
      }, isLoggedInDemo);
    } else {
      navigateTo(LOGIN.path);
    }
  });
  return null;
};
